import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useElementSize from 'hooks/useElementSize';
import { ASSET_WRITE, hasPrivilege } from 'utils/privileges';
import config from 'utils/config';
import AssetEditor from 'screens/AssetEditor';
import AssetAnalyticsPage from 'screens/AssetAnalyticsPage';
import AssetSharePage from 'screens/AssetSharePage';
import { useGetSharingPermissions } from 'screens/ShareModal';
import { useGetTabInfo } from 'screens/AssetManager';
import EventSessionsManager from 'screens/EventSessionsManager';
import SingleAssetHeader from './SingleAssetHeader';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SingleAssetManager(_ref) {
  var inContentManagerContext = _ref.inContentManagerContext,
    hasOpenOption = _ref.hasOpenOption,
    titleId = _ref.titleId,
    asset = _ref.asset,
    parentPlaylist = _ref.parentPlaylist,
    getIsActiveTab = _ref.getIsActiveTab,
    getTabLink = _ref.getTabLink,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    setHasChanges = _ref.setHasChanges;
  var location = useLocation();
  var navigate = useNavigate();
  var _useElementSize = useElementSize(),
    editorPageHeaderHeight = _useElementSize.height,
    elementRef = _useElementSize.elementRef;
  var isAssetAdmin = hasPrivilege(ASSET_WRITE);
  var isEventAsset = asset.type === 'event';
  var availableTabs = useMemo(function () {
    var tabs = ['details'];
    if (isAssetAdmin) {
      tabs.push('share');

      // We do not show the Sessions tab for events if we're in the Playlist Content Manager
      // due to complexity around event session emails being potentially triggered too early
      if (isEventAsset && config.eventAssets && !inContentManagerContext) {
        tabs.push('sessions');
      } else if (!isEventAsset) {
        tabs.push('analytics');
      }
    }
    return tabs;
  }, [isAssetAdmin, isEventAsset, inContentManagerContext]);
  var _useGetSharingPermiss = useGetSharingPermissions({
      name: asset.name,
      contentIds: [asset.id],
      contentParentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id
    }),
    shareData = _useGetSharingPermiss.shareData;
  var _useGetTabInfo = useGetTabInfo({
      getTabLink: getTabLink,
      getIsActiveTab: getIsActiveTab,
      location: location,
      tabs: availableTabs
    }),
    tabLinks = _useGetTabInfo.tabLinks,
    activeTab = _useGetTabInfo.activeTab;
  var hasNestedSessionHeader = activeTab === 'sessions' && new URLSearchParams(location.search).get('sessionId') !== null;
  useEffect(function () {
    var currentTab = new URLSearchParams(location.search).get('tab');
    if (currentTab !== null && !availableTabs.includes(currentTab)) {
      navigate(getTabLink({
        tabName: 'details',
        location: location
      }), {
        replace: true
      });
    }
  }, [availableTabs, getTabLink, location, navigate]);
  var renderActiveTab = function renderActiveTab() {
    switch (activeTab) {
      case 'details':
        return /*#__PURE__*/_jsx(AssetEditor, {
          asset: asset,
          parentPlaylist: parentPlaylist,
          onSubmit: onSubmit,
          onClose: onClose,
          inContentManagerContext: inContentManagerContext,
          setHasChanges: setHasChanges
        });
      case 'analytics':
        return /*#__PURE__*/_jsx(AssetAnalyticsPage, {
          id: asset.id,
          playlistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
          name: asset.name,
          type: asset.type
        });
      case 'share':
        return /*#__PURE__*/_jsx(AssetSharePage, {
          id: asset.id,
          shareData: shareData,
          playlistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id
        });
      case 'sessions':
        return /*#__PURE__*/_jsx(EventSessionsManager, {
          inAssetManagerContext: true,
          eventId: asset.id,
          stickyHeaderCompensation: editorPageHeaderHeight
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SingleAssetHeader, {
      wrapperRef: elementRef,
      isCollapsed: hasNestedSessionHeader,
      hasOpenOption: hasOpenOption,
      parentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
      titleId: titleId,
      asset: asset,
      onClose: onClose,
      shareData: shareData,
      tabLinks: tabLinks
    }), renderActiveTab()]
  });
}
export default SingleAssetManager;